<template>
  <div class="flex homePage">
    <div class="left">
      <!-- 头部 -->
      <div class="mapTop">
        <!-- 车辆统计 -->
        <div class="carCount">
          <!-- <div class="title">车辆统计</div> -->
          <div class="fir">
            <div class="countCard mid" v-for="(item, index) in carCountData" :key="item.id"
              @click="toCarManage(item.name)">
              <img class="iconImg" :src="imgList[index]" />
              <div>
                <div class="name">{{ item.name || "" }}(辆)</div>
                <div class="num">{{ item.carNum || 0 }}</div>
              </div>
            </div>
          </div>
          <!-- <div class="sec">
          <div class="countCard" v-for="(item, index) in carCountData.slice(3, 7)" @click="toCarManage(item.name)"
            :key="item.id">
            <img class="iconImg" :src="imgList[index + 3]" />
            <div>
              <div class="name">{{ item.name || "" }}(辆)</div>
              <div class="num">{{ item.carNum || 0 }}</div>
            </div>
          </div>
        </div> -->
        </div>
        <!-- 车辆状态 -->
        <!-- <div class="carStatus">
        <div class="title">车辆状态</div>
        <div class="statusFir">
          <div class="statusCard">
            <div class="statusLeft">

            </div>
            <el-progress type="circle" :width="20" :show-text="false" stroke-linecap="butt"
              :percentage="carStatusData.onlinePercent" color="rgba(91, 143, 249, 1)"
              define-back-color="rgba(91, 143, 249, 0.25)" class="progressCard"></el-progress>
          </div>
          <div class="statusLine"></div>
          <div class="statusCard">
            <div class="statusLeft">

            </div>
            <el-progress type="circle" :width="20" :show-text="false" stroke-linecap="butt"
              :percentage="carStatusData.offlinePercent" color="rgba(93, 112, 146, 1)"
              define-back-color="rgba(93, 112, 146, 0.25)" class="progressCard"></el-progress>
          </div>
        </div>
        <div class="statusSec">
          <div class="statusCard">

            <el-progress type="circle" :width="20" :show-text="false" stroke-linecap="butt"
              :percentage="carStatusData.breakdownPercent" color="rgba(253, 83, 118, 1)"
              define-back-color="rgba(253, 83, 118, 0.25)" class="progressCard"></el-progress>
          </div>
          <div class="statusLine"></div>
          <div class="statusCard">

            <el-progress type="circle" :width="20" :show-text="false" stroke-linecap="butt"
              :percentage="carStatusData.abnormalPercent" color="rgba(246, 189, 22, 1)"
              define-back-color="rgba(246, 189, 22, 0.25)" class="progressCard"></el-progress>
          </div>
        </div>
      </div> -->

        <div class="firCard">
          <div class="companyCard">
            <div class="lineCard"></div>
            <div class="name">运营公司(家)</div>
            <div class="value">{{ carStatusData.enterprise || 0 }}</div>
          </div>
          <div class="companyCard">
            <div class="statusLeft">
              <div class="name">运营车辆(辆)</div>
              <div class="value">{{ carStatusData.car || 0 }}</div>
            </div>


            <div class="statusLeft">
              <div class="name">在线</div>
              <div class="value">{{ carStatusData.online || 0 }}</div>
            </div>
            <div class="statusLeft">
              <div class="name">离线</div>
              <div class="value onLine">{{ carStatusData.offline || 0 }}</div>
            </div>

            <div class="statusLeft">
              <div class="name">故障</div>
              <div class="value breakdown">{{ carStatusData.breakdown || 0 }}</div>
            </div>

            <div class="statusLeft">
              <div class="name">异常</div>
              <div class="value abnormal">{{ carStatusData.abnormal || 0 }}</div>
            </div>
          </div>
          <!-- <div class="companyCard">
          <div class="lineCard"></div>
          <div class="name">驾驶员(人)</div>
          <div class="value">{{ carStatusData.driver || 0 }}</div>
        </div> -->
        </div>


      </div>
      <div class="leftContent">
        <!-- 左边统计 -->
        <div class="leftData">
          <div class="warnCount">
            <div class="title ">
              <div class="title1">预警类型排行</div>
            </div>
            <div class="countChart" id="countChart"></div>
          </div>
          <!-- 预警排行榜(前10) -->
          <div class="warnRank">
            <div class="title mt-0">
              <div class="title3">预警数量排行</div>
            </div>
            <div class="rankChart" id="rankChart">
              <div class="rankItem" v-for="(item, index) in rankList" :key="index">
                <div class="left">{{ item.name }}</div>
                <div class="rankRight" :class="[0, 1, 2].includes(index) ? 'rankColor' : ''">
                  <div class="rank" :style="{ width: item.percentage + '%' }" :title="`${item.num || 0}`"></div>
                </div>
              </div>
            </div>
            <div class="noData" v-if="rankList.length == 0">
              <el-empty description="暂无数据" :image-size="80"></el-empty>
            </div>
          </div>
        </div>
        <!-- 左边 地图 -->
        <div class="leftMap">
          <div class="mapContainer" id="mapContainer"></div>
        </div>
        <!-- 右边 内容 -->
        <div class="right">

          <!-- 今日预警 -->
          <div class="todayWarn">
            <div class="title">
              <div class="title4">今日预警情况</div>
            </div>
            <div class="warnList" v-if="warnList.length > 0">
              <div class="warnItem" v-for="(item, index) in warnList" :key="index" :class="item.warnLevel
                ? ['oneWarn', 'twoWarn', 'threeWarn', 'fourWarn'][
                item.warnLevel - 1
                ]
                : 'fiveWarn'
                ">
                <div class="grade">
                  {{
                    item.warnLevel
                      ? ["一级", "二级", "三级", "四级"][item.warnLevel - 1]
                      : "-"
                  }}
                </div>
                <div class="info">
                  {{ item.vehicleNumber }} {{ item.warnType }} {{ item.keepTime }}
                  {{ item.startTime }}
                </div>
              </div>
            </div>
            <div class="noData" v-else>
              <el-empty description="暂无数据" :image-size="80"></el-empty>
            </div>
          </div>
          <!-- 预警情况统计 -->
          <div class="warnCount">
            <div class="title ">
              <div class="title2">预警情况统计</div>
            </div>
            <el-table v-if="tableData.length" :data="tableData" border stripe style="width: 100%" :height="321">
              <el-table-column prop="name" label="车辆类型">
                <template #default="{ row }">
                  <span class="operate_type" @click="toWarningList(row.name)">{{ row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="total" label="预警总数"></el-table-column>
              <el-table-column prop="processed" label="已处理数"></el-table-column>
              <el-table-column prop="unprocessed" label="未处理数"></el-table-column>
              <el-table-column prop="rate" label="处置率"></el-table-column>
            </el-table>
            <div class="noData" v-else>
              <el-empty description="暂无数据" :image-size="80"></el-empty>
            </div>
          </div>

        </div>
      </div>


    </div>


  </div>
</template>

<script>
import * as echarts from "echarts";
import html2canvas from "html2canvas";
import AMapLoader from "@amap/amap-jsapi-loader";
import flvjs from "flv.js";
import moment from 'moment'
import '../../utils/css/swfobject-h5.css'
import '../../utils/css/DPlayer.min.css'
import {
  getCarCount,
  getCarStatusCount,
  getMapCarList,
  getCarWarnList,
  getWarnGroupCount,
  getWarnGroupCountTop10,
  getRealVideo,
  playDetection,
  closeRealVideo,
  getAllWarnGroupVehicleType
} from "./service";
export default {
  data() {
    return {
      flvPlayer: null,
      videoTimer: null,
      activeIndex: "1",
      activeIndex2: "1",
      timer: null,
      markers: [],
      map: null,
      AMap: null,
      infoWindow: null,
      imgList: [
        require("../../assets//homeImg/img3.png"),
        require("../../assets//homeImg/img6.png"),
        require("../../assets//homeImg/img7.png"),
        require("../../assets//homeImg/img5.png"),
        require("../../assets//homeImg/img1.png"),
        require("../../assets//homeImg/img4.png"),
        require("../../assets//homeImg/img2.png"),
      ],
      countList: [], //预警情况统计数据
      rankList: [], //预警排行榜数据
      carList: [], //车辆列表数据
      carCountData: [], //车辆统计数据
      carStatusData: {}, //车辆状态数据
      warnList: [], //预警列表数据
      opencARiD: '', //车辆id
      serverIp: "", //监控ip
      serverPort: "", //监控端口
      carId: "", //监控车辆
      urlLink: '',//视频地址
      tableData: [], //预警情况统计数据
      showFlv: false,//是否显示flv视频
      tokenID: 'shehongchuzu',
      plugin: true,
      oWebControl: null,   //插件对象
      initCount: 0,
      pubKey: '',         //公钥加密
      video_init_data: {
        appkey: '27273246',
        appSecret: 'vjvZA7X4hHUc0SbONht9',
        ip: '112.18.106.230',
        port: '443',
        snapDir: 'D:\\SnapDir',
        videoDir: 'D:\\VideoDir',
        layout: '1x1',
        encryptedFields: 'secret',
        enableHttps: '1',
      },
      video_play_data: {
        cameraIndexCode: '',
        streamMode: 0,
        transMode: 1,
        gpuMode: 0,
        wndId: -1,
      },
      //videoWidth videoHeight screenWidth screenHeight
      //这四个参数为了使插件大小和屏幕宽度一致变化
      videoWidth: 400,
      videoHeight: 200,
      screenWidth: document.documentElement.clientWidth,//屏幕宽度
      screenHeight: document.documentElement.clientHeight,//屏幕高度
      //设置窗口遮挡 根据浏览器大小变化视频插件的大小
      iLastCoverLeft: 0,
      iLastCoverTop: 0,
      iLastCoverRight: 0,
      iLastCoverBottom: 0,
      IsHai: false,
      videoLoading: false, // 视频加载状态
      videoLoadingText: '视频加载中...', // 视频加载提示文本
      videoLoadingError: false, // 视频加载错误
      hstCheckTimer: null, // HST 播放检测定时器
    };
  },
  watch: {
    map(val) {
      if (val) {
        HTMLCanvasElement.prototype.getContext = (function (origFn) {
          return function (type, attributes) {
            if (type.indexOf("webgl") > -1) {
              attributes = Object.assign({}, attributes, {
                preserveDrawingBuffer: true,
              });
            }
            return origFn.call(this, type, attributes);
          };
        })(HTMLCanvasElement.prototype.getContext);
      }
    },
  },
  filters: {},

  created() {
    window.toCarDetail = (record) => {
      this.toCarDetail(record);
    };
    window.fullScreen = () => {
      this.fullScreen();
    };
    window.shotScreen = () => {
      this.shotScreen();
    };
  },
  mounted() {
    // 调用所有接口
    this.getCarCountData();
    this.getCarStatusData();
    // this.getMapCarData(); // 移除这里的调用，因为 initMap 中会调用
    this.getWarnListData();
    this.getWarnGroupData();
    this.getWarnTop10Data();
    this.getVehicleType();

    this.initMap();
    if (this.timer) {
      clearInterval(this.timer);
    }
    // 设置定时器，每分钟刷新一次数据
    this.timer = setInterval(() => {
      this.getCarCountData();
      this.getCarStatusData();
      this.getMapCarData(); // 保留定时器中的调用
      this.getWarnListData();
      this.getWarnGroupData();
      this.getWarnTop10Data();
      this.getVehicleType();
    }, 60000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.opencARiD && window.hstVideoPlay && window.playerobject) {
      window.hstVideoPlay.historyCloseVideo(this.opencARiD, '1');
    }
    if (this.oWebControl != null) {
      this.oWebControl.JS_DestroyWnd();
    }

    this.destroyPlayer();
    if (this.markers && this.markers.length > 0) {
      this.markers.forEach((marker) => {
        marker.setMap(null);
      });
      this.markers = [];
    }
    if (this.infoWindow) {
      this.infoWindow.close();
    }
    if (this.flvPlayer) {
      this.flvPlayer.destroy();
      this.flvPlayer = null;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.infoWindow) {
      this.infoWindow.close();
    }
    if (this.flvPlayer) {
      this.flvPlayer.destroy();
      this.flvPlayer = null;
    }
    next();
  },
  methods: {
    toWarningList(name) {
      this.$router.push({
        path: "/early-warning",
        query: { name },
      });
    },
    getVehicleType() {
      getAllWarnGroupVehicleType().then(res => {
        this.tableData = res;
      })
    },
    toCarManage(id) {
      this.$router.push({
        path: "/car-manage",
        query: { id },
      });
    },
    // 获取车辆统计数据
    async getCarCountData() {
      try {
        const res = await getCarCount();
        // let list=['客运','危货运输','普货运输','公交车','出租车','交邮','网约车']
        this.carCountData = res;
      } catch (error) {
        this.$message.error("获取车辆统计数据失败");
      }
    },
    // 获取车辆状态数据
    async getCarStatusData() {
      try {
        const res = await getCarStatusCount();
        // 设置默认值为0，防止空值
        const online = Number(res.online) || 0;
        const offline = Number(res.offline) || 0;
        const breakdown = Number(res.breakdown) || 0;
        const abnormal = Number(res.abnormal) || 0;
        const enterprise = Number(res.enterprise) || 0;
        const car = Number(res.car) || 0;
        const driver = Number(res.driver) || 0;

        // 计算总数
        const total = online + offline + breakdown + abnormal;

        // 计算百分比，如果总数为0则百分比为0
        const onlinePercent =
          total > 0 ? Math.round((online / total) * 100) : 0;
        const offlinePercent =
          total > 0 ? Math.round((offline / total) * 100) : 0;
        const breakdownPercent =
          total > 0 ? Math.round((breakdown / total) * 100) : 0;
        const abnormalPercent =
          total > 0 ? Math.round((abnormal / total) * 100) : 0;
        // 更新数据
        this.carStatusData = {
          online,
          offline,
          breakdown,
          abnormal,
          enterprise,
          car,
          driver,
          total,
          onlinePercent,
          offlinePercent,
          breakdownPercent,
          abnormalPercent,
        };
      } catch (error) {
        this.$message.error("获取车辆状态数据失败");
        // 设置默认值
        this.carStatusData = {
          online: 0,
          offline: 0,
          breakdown: 0,
          abnormal: 0,
          enterprise: 0,
          car: 0,
          driver: 0,
          total: 0,
          onlinePercent: 0,
          offlinePercent: 0,
          breakdownPercent: 0,
          abnormalPercent: 0,
        };
      }
    },
    // 获取地图车辆数据
    async getMapCarData() {
      try {
        const res = await getMapCarList();
        this.carList = res;
        // 确保地图已初始化后再更新标记
        if (this.AMap && this.map) {
          this.updateMarkers(res);
        }
      } catch (error) {
        this.$message.error("获取地图车辆数据失败");
      }
    },
    // 获取预警列表数据
    async getWarnListData() {
      try {
        const res = await getCarWarnList({ pageNum: 1, pageSize: 100000, startTime: moment().format('YYYY-MM-DD 00:00:00'), endTime: moment().format('YYYY-MM-DD 23:59:59') });
        this.warnList = res.page.records;
      } catch (error) {
        this.$message.error("获取预警列表数据失败");
      }
    },
    // 获取预警统计情况数据
    async getWarnGroupData() {
      try {
        const res = await getWarnGroupCount();
        this.countList = res.filter(item => item.warnType != '其他报警');
        this.getCountList();
      } catch (error) {
        this.$message.error("获取预警统计情况数据失败");
      }
    },
    // 获取预警排行数据
    async getWarnTop10Data() {
      try {
        const res = await getWarnGroupCountTop10();
        // 判断返回的数组是否为空
        if (!res || res.length === 0) {
          this.rankList = [];
          return;
        }
        // 计算所有num的总和
        const total = res.reduce((sum, item) => sum + (item.num || 0), 0);
        // 为每个数据项添加百分比属性
        this.rankList = res.map((item) => ({
          ...item,
          percentage:
            total > 0 ? (((item.num || 0) / total) * 100).toFixed(2) : 0,
        }));
      } catch (error) {
        this.$message.error("获取预警排行数据失败");
        this.rankList = [];
      }
    },
    // 初始化地图
    initMap() {
      window._AMapSecurityConfig = {
        securityJsCode: this.$secretKey,
      };
      AMapLoader.load({
        key: this.$mapKey,
        version: "2.0",
        plugins: [
          "AMap.ToolBar",
          "AMap.AutoComplete",
          "AMap.Geocoder",
          "AMap.MarkerCluster",
          "AMap.Geocoder",
        ],
      })
        .then((AMap) => {
          this.AMap = AMap;
          this.map = new AMap.Map("mapContainer", {
            center: [105.574542, 30.5061493],
            zoom: 8,
          });
          this.infoWindow = new AMap.InfoWindow({
            offset: new AMap.Pixel(30, 30),
            autoMove: true,
            anchor: "top-center",
          });
          // 添加信息弹窗关闭事件监听
          this.infoWindow.on("close", () => {
            this.destroyPlayer();
            if (this.oWebControl != null) {
              this.oWebControl.JS_DestroyWnd();
            }
          });
          this.map.on("click", (e) => {
            this.infoWindow.close();
            if (this.oWebControl != null) {
              this.oWebControl.JS_DestroyWnd();
            }
            if (this.opencARiD && window.hstVideoPlay && window.playerobject) {
              window.hstVideoPlay.historyCloseVideo(this.opencARiD, '1');
            }
          });
          this.getMapCarData();
        })
        .catch((e) => {
          this.$message.error("地图加载失败");
        });
    },
    // 更新地图标记
    updateMarkers(arr) {
      if (!this.AMap) {
        return;
      }
      if (this.markers && this.markers.length > 0) {
        this.markers.forEach((marker) => {
          marker.setMap(null);
        });
        this.markers = [];
      }

      if (arr.length > 0) {
        const iconMap = {
          出租车: {
            icon: require("../../assets/homeImg/taxi.png"),
            size: new this.AMap.Size(Math.round(25 * 1.7), Math.round(12 * 1.7)),
          },
          公交车: {
            icon: require("../../assets/homeImg/bus.png"),
            size: new this.AMap.Size(Math.round(21 * 1.7), Math.round(11 * 1.7)),
          },
          危货运输: {
            icon: require("../../assets/homeImg/risk.png"),
            size: new this.AMap.Size(Math.round(23 * 1.7), Math.round(11 * 1.7)),
          },
          交邮: {
            icon: require("../../assets/homeImg/outing.png"),
            size: new this.AMap.Size(Math.round(20 * 1.7), Math.round(11 * 1.7)),
          },
          货运: {
            icon: require("../../assets/homeImg/expressage.png"),
            size: new this.AMap.Size(Math.round(20 * 1.7), Math.round(11 * 1.7)),
          },
          网约车: {
            icon: require("../../assets/homeImg/online.png"),
            size: new this.AMap.Size(Math.round(25 * 1.7), Math.round(11 * 1.7)),
          },
          客运: {
            icon: require("../../assets/homeImg/passenger.png"),
            size: new this.AMap.Size(Math.round(23 * 1.7), Math.round(11 * 1.7)),
          },
        };

        arr.forEach((item, index) => {
          // 检查必要字段
          if (!item.operateType || !item.longitude || !item.latitude) {
            return;
          }

          const iconConfig = iconMap[item.operateType];
          if (!iconConfig) {
            return;
          }

          let marker = new this.AMap.Marker({
            position: [Number(item.longitude), Number(item.latitude)],
            map: this.map,
            icon: new this.AMap.Icon({
              size: iconConfig.size,
              image: iconConfig.icon,
              imageSize: iconConfig.size,
              imageOffset: new this.AMap.Pixel(0, 0),
            }),
          });

          // 添加点击事件
          marker.on("click", async (e) => {
            const isHst = ['17235341', '82296583'].includes(item.companyCode);
            const isHai = item.companyCode == '25439966';
            this.IsHai = isHai;
            this.showFlv = false;
            if (this.opencARiD && window.hstVideoPlay && window.playerobject) {
              window.hstVideoPlay.historyCloseVideo(this.opencARiD, '1');
            }
            this.opencARiD = item.id;
            console.log("点击了车辆", item);

            // 先渲染弹窗，确保 hstplayer/divPlugin 已存在
            this.infoWindow.setContent(
              this.listRender({
                ...item,
                drivingTime: this.formatterTime(item.drivingTime || 0),
                location: "加载中...",
              })
            );
            this.infoWindow.open(this.map, e.target.getPosition());

            // 如果已经有视频在播放，先销毁
            if (isHst) {
              // 进入 HST 播放时重置 loading 状态
              this.videoLoading = true;
              this.videoLoadingError = false;
              this.videoLoadingText = '视频加载中...';
              this.updateVideoLoadingDisplay();
              // 清理上次的检测定时器
              if (this.hstCheckTimer) {
                clearInterval(this.hstCheckTimer);
                this.hstCheckTimer = null;
              }
              this.loadScripts().then(() => {
                this.$nextTick(() => {
                  //视频参数
                  var params = {
                    allowFullscreen: "true",
                    allowScriptAccess: "always",
                    bgcolor: "#FFFFFF",
                    wmode: "transparent",
                  };
                  const playerEl = document.getElementById("hstplayer");
                  if (!playerEl) {
                    this.$message.error("播放器容器不存在");
                    this.videoLoading = false;
                    this.updateVideoLoadingDisplay();
                    return;
                  }
                  //初始化视频插件
                  window.hstVideoPlay.init(this.tokenID, "hstplayer", params, 1); // 设置为1个窗口
                  setTimeout(() => {
                    hstVideoPlay.realTimeOpenVideo(item.deviceId, '2');
                    // 检测播放器加载情况，成功后关闭 loading
                    const start = Date.now();
                    this.hstCheckTimer = setInterval(() => {
                      const playerEl = document.getElementById("hstplayer");
                      const h5El = document.getElementById("HstH5Video-0");
                      const hasPlayer =
                        (window.playerobject && window.playerobject.parentNode) ||
                        (h5El && h5El.children && h5El.children.length > 0);
                      if (hasPlayer) {
                        this.videoLoading = false;
                        this.videoLoadingError = false;
                        this.videoLoadingText = '视频加载中...';
                        this.updateVideoLoadingDisplay();
                        clearInterval(this.hstCheckTimer);
                        this.hstCheckTimer = null;
                      } else if (Date.now() - start > 8000) {
                        this.videoLoading = false;
                        this.videoLoadingError = true;
                        this.videoLoadingText = '视频加载超时，请重试';
                        this.updateVideoLoadingDisplay();
                        clearInterval(this.hstCheckTimer);
                        this.hstCheckTimer = null;
                      }
                    }, 500);
                  }, 1000);
                });
              })
                .catch((e) => {
                  console.log('4444444444444444444444', e)
                  this.videoLoading = false;
                  this.videoLoadingError = true;
                  this.videoLoadingText = "视频加载失败";
                  this.updateVideoLoadingDisplay();
                  this.$message.error("视频加载失败");
                });
            } else if (isHai) {
              getRealVideo({ id: item.id }).then(res => {
                console.log('qwewqeqw', res);
                this.video_play_data.cameraIndexCode = res.url;
                this.initPlugin();
                // 监听窗口变化
                let _this = this;
                window.onresize = function () { // 定义窗口大小变更通知事件
                  _this.screenWidth = document.documentElement.clientWidth; //窗口宽度
                  _this.screenHeight = document.documentElement.clientHeight; //窗口高度
                };
                window.addEventListener('scroll', function () {
                  if (this.oWebControl != null) {
                    if (res.url) {
                      this.oWebControl.JS_Resize(this.videoWidth, this.videoHeight);
                      this.setWndCover();
                    }

                  }
                });
              })
            } else {
              this.videoLoading = true;
              this.videoLoadingError = false;
              this.videoLoadingText = '视频加载中...';
              this.showFlv = true;
              this.getVideoUrl(item.id)
            }

            try {
              // 使用高德地图API获取地址信息
              const geocoder = new this.AMap.Geocoder();
              const location = [Number(item.longitude), Number(item.latitude)];

              const [addressResult, videoRes] = await Promise.all([
                new Promise((resolve) => {
                  geocoder.getAddress(location, (status, result) => {
                    if (status === "complete" && result.regeocode) {
                      resolve(result.regeocode.formattedAddress);
                    } else {
                      resolve("未知地址");
                    }
                  });
                }),
              ]);
              this.initVideoPlayer(item.id);


              // 更新弹窗内容
              this.infoWindow.setContent(
                this.listRender({
                  ...item,
                  drivingTime: this.formatterTime(item.drivingTime || 0),
                  location: addressResult,
                })
              );


            } catch (error) {
              this.infoWindow.setContent(
                '<div style="padding: 20px;text-align: center;color: red;">获取车辆信息失败</div>'
              );
            }
          });

          // 将marker添加到数组中
          this.markers.push(marker);
        });
      }
    },
    // 获取视频地址
    async getVideoUrl(carId) {
      this.carId = carId;
      try {
        const res = await getRealVideo({ id: carId });
        // 将RTSP流转换为FLV流
        this.serverIp = res.serverIp;
        this.serverPort = res.serverPort;
        this.urlLink = res.url;
        this.initVideoPlayer(carId);
      } catch (error) {
        console.error("获取视频地址失败", error);
        return {};
      }
    },

    // 初始化视频播放器
    initVideoPlayer(id) {
      console.log('11111', this.serverIp, '2222222222', this.serverPort)
      console.log('33333333333333333', this.urlLink)
      if (!this.urlLink) {
        this.videoLoading = true;
        this.videoLoadingError = false;
        this.videoLoadingText = '视频加载中。。。';
        return;
      }

      // 验证URL格式
      try {
        new URL(this.urlLink);
      } catch (e) {
        console.error('视频URL格式无效:', this.urlLink);
        this.videoLoading = false;
        this.videoLoadingError = true;
        this.videoLoadingText = '视频地址格式无效';
        return;
      }

      // 先销毁之前的播放器
      if (this.flvPlayer) {
        this.flvPlayer.destroy();
        this.flvPlayer = null;
      }

      // 获取video元素
      const video = document.getElementById("monitoringCard");
      if (!video) {
        console.error("Video element not found");
        this.showVideoError('视频元素未找到');
        return;
      }

      // 检查flv.js是否支持
      if (flvjs.isSupported()) {
        try {
          playDetection(id || this.carId).then((res) => {
            this.flvPlayer = flvjs.createPlayer({
              type: "flv", //视频类型
              isLive: true, //是否为直播
              cors: true, //是否开启跨域
              hasAudio: false, //是否开启音频
              hasVideo: true, //是否开启视频
              // url: `http://${this.serverIp}:${this.serverPort}/live?port=1935&app=flv&stream=${this.carId}`, // 后端拿到的视频路径
              url: this.urlLink, // 后端拿到的视频路径
              enableWorker: true, //启用 Web Worker 进程来加速视频的解码和处理过程
              enableStashBuffer: false, // 启用数据缓存机制，提高视频的流畅度和稳定性。
              stashInitialSize: 1024, // 初始缓存大小。单位：字节。建议针对直播：调整为1024kb
              stashInitialTime: 0.2, // 缓存初始时间。单位：秒。建议针对直播：调整为200毫秒
              seekType: "range", // 建议将其设置为"range"模式，以便更快地加载视频数据，提高视频的实时性。
              lazyLoad: false, //关闭懒加载模式，从而提高视频的实时性。建议针对直播：调整为false
              lazyLoadMaxDuration: 0.2, // 懒加载的最大时长。单位：秒。建议针对直播：调整为200毫秒
              // deferLoadAfterSourceOpen: false, // 不预先加载视频数据，在 MSE（Media Source Extensions）打开后立即加载数据，提高视频的实时性。建议针对直播：调整为false
            }, {
              deferLoadAfterSourceOpen: false
            });

            // 添加MediaSource状态监听
            this.flvPlayer.on(flvjs.Events.MEDIA_SOURCE_OPEN, () => {
              console.log('MediaSource已打开，开始加载视频流...');
            });

            this.flvPlayer.on(flvjs.Events.MEDIA_SOURCE_ENDED, () => {
              console.log('MediaSource已结束');
              this.showVideoError('视频流已结束');
            });

            this.flvPlayer.on(flvjs.Events.LOADING_COMPLETE, () => {
              console.log('视频流加载完成');
              this.videoLoading = false;
              this.videoLoadingError = false;
              this.hideVideoError();
              this.updateVideoLoadingDisplay();
            });

            this.flvPlayer.on(flvjs.Events.ERROR, (err) => {
              console.error('FLV播放器错误:', err);
              let errorMsg = '视频播放失败';
              if (err.detail && err.detail.code) {
                switch (err.detail.code) {
                  case flvjs.ErrorCodes.NETWORK_ERROR:
                    errorMsg = '网络错误，无法连接到视频服务器';
                    break;
                  case flvjs.ErrorCodes.MEDIA_ERROR:
                    errorMsg = '视频流格式错误';
                    break;
                  case flvjs.ErrorCodes.MUX_ERROR:
                    errorMsg = '视频流解析错误';
                    break;
                  default:
                    errorMsg = `播放错误: ${err.detail.code}`;
                }
              }
              this.videoLoading = false;
              this.videoLoadingError = true;
              this.videoLoadingText = errorMsg;
              this.showVideoError(errorMsg);
              this.updateVideoLoadingDisplay();
            });

            console.log('1111111111111111', this.urlLink)
            let video = document.getElementById("monitoringCard");
            console.log('222222222222222222222', video)
            this.flvPlayer.attachMediaElement(video); // video容器

            // 设置加载超时
            const loadTimeout = setTimeout(() => {
              if (this.flvPlayer && !video.readyState) {
                console.warn('视频加载超时');
                this.showVideoError('设备离线');
              }
            }, 10000); // 10秒超时

            this.flvPlayer.load();
            console.log('666666666666666666', this.flvPlayer)

            this.flvPlayer
              .play()
              .then((res) => {
                // 显示视频元素
                console.log('视频播放成功', res)
                this.videoLoading = false;
                this.videoLoadingError = false;
                video.style.display = 'block';
                clearTimeout(loadTimeout); // 清除超时定时器
                this.updateVideoLoadingDisplay();
                // 隐藏空状态
                const emptyElement = video.parentElement.querySelector('.el-empty');
                if (emptyElement) {
                  emptyElement.style.display = 'none';
                }
                // 隐藏离线提示
                const offlineElement = video.parentElement.querySelector('.video-offline');
                if (offlineElement) {
                  offlineElement.style.display = 'none';
                }

                this.videoTimer = setInterval(() => {
                  playDetection(this.carId);
                }, 5000);
              })
              .catch((err) => {
                console.log('播放失败', err);
                clearTimeout(loadTimeout); // 清除超时定时器
                this.videoLoading = false;
                this.videoLoadingError = true;
                this.videoLoadingText = '设备离线，无法播放视频';
                this.updateVideoLoadingDisplay();

                // 移除重复的离线提示，只保留我们新的loading错误提示
                const offlineElement = video.parentElement.querySelector('.video-offline');
                if (offlineElement) {
                  offlineElement.style.display = 'none'; // 隐藏而不是创建
                }

                this.destroyPlayer();
              });
          }).catch((error) => {
            console.error('playDetection调用失败:', error);
            this.videoLoading = false;
            this.videoLoadingError = true;
            this.videoLoadingText = '视频服务调用失败';
            this.showVideoError('视频服务调用失败');
            this.updateVideoLoadingDisplay();
          });
        } catch (error) {
          console.error("创建播放器失败:", error);
          this.videoLoading = false;
          this.videoLoadingError = true;
          this.videoLoadingText = '创建播放器失败';
          this.showVideoError('创建播放器失败');
          this.updateVideoLoadingDisplay();
        }
      } else {
        console.error("当前浏览器不支持flv.js");
        this.videoLoading = false;
        this.videoLoadingError = true;
        this.videoLoadingText = '浏览器不支持FLV视频格式';
        this.showVideoError('浏览器不支持FLV视频格式');
        this.updateVideoLoadingDisplay();
      }
    },

    // 显示视频错误信息 - 改为使用新的统一错误提示系统
    showVideoError(message) {
      // 使用新的统一错误提示系统，不再创建重复的离线提示
      this.videoLoading = false;
      this.videoLoadingError = true;
      this.videoLoadingText = message;
      this.updateVideoLoadingDisplay();
    },

    // 隐藏视频错误信息 - 改为使用新的统一错误提示系统
    hideVideoError() {
      // 使用新的统一错误提示系统，隐藏错误状态
      this.videoLoadingError = false;
      this.updateVideoLoadingDisplay();
    },

    // 更新视频loading状态显示
    updateVideoLoadingDisplay() {
      const loadingElement = document.getElementById('videoLoading');
      const errorElement = document.getElementById('videoError');

      if (loadingElement) {
        loadingElement.style.display = this.videoLoading ? 'flex' : 'none';
        const loadingText = loadingElement.querySelector('div:last-child');
        if (loadingText) {
          loadingText.textContent = this.videoLoadingText;
        }
      }

      if (errorElement) {
        errorElement.style.display = this.videoLoadingError ? 'flex' : 'none';
        const errorText = errorElement.querySelector('div:last-child');
        if (errorText) {
          errorText.textContent = this.videoLoadingText;
        }
      }
    },

    destroyPlayer() {
      if (this.hstCheckTimer) {
        clearInterval(this.hstCheckTimer);
        this.hstCheckTimer = null;
      }
      this.urlLink = ""
      this.videoLoading = false
      this.videoLoadingError = false
      this.videoLoadingText = '视频加载中...'
      // 销毁播放器释放资源
      if (this.flvPlayer) {
        if (this.videoTimer) clearInterval(this.videoTimer);
        if (this.carId) {
          closeRealVideo(this.carId).then((res) => {
            this.flvPlayer.pause();
            this.flvPlayer.unload();
            this.flvPlayer.detachMediaElement();
            this.flvPlayer.destroy();
            this.flvPlayer = null;

            // 恢复空状态的显示
            const video = document.getElementById("monitoringCard");
            if (video) {
              video.style.display = 'none';
              const emptyElement = video.parentElement.querySelector('.el-empty');
              if (emptyElement) {
                emptyElement.style.display = 'block';
              }
              // 隐藏离线提示
              this.hideVideoError();
            }
          });
        }

      }
    },

    // 处理视频错误
    handleVideoError(event) {
      console.error("视频加载失败", event);
      if (this.flvPlayer) {
        this.flvPlayer.destroy();
        this.flvPlayer = null;
      }
      this.infoWindow.setContent(
        '<div style="padding: 20px;text-align: center;color: red;">视频加载失败，请稍后重试</div>'
      );
    },

    listRender(record) {
      return `<div style="background: #ffffff; padding: 24px 20px;z-index: 999">
        <div style="position: relative; width: 460px; height: 500px">
          <div v-if="${this.showFlv}" style="width: 460px; height: 300px; border-radius: 9px; background: #f5f5f5; display: flex; justify-content: center; align-items: center; flex-direction: column; position: relative;">
            <video
              ref="video"
              style="width: 460px; height: 200px; border-radius: 9px; display: none"
              id="monitoringCard"
              ref="monitoringCard"
              :controls="false"
              autoPlay
              width="620">
            </video>

            <!-- 视频加载动画 -->
            <div id="videoLoading" style="display: ${this.videoLoading ? 'flex' : 'none'}; flex-direction: column; align-items: center; justify-content: center; z-index: 10;">
              <div style="width: 40px; height: 40px; border: 4px solid #f3f3f3; border-top: 4px solid #1677ff; border-radius: 50%; animation: spin 1s linear infinite; margin-bottom: 10px;"></div>
              <div style="color: #666; font-size: 14px;">${this.videoLoadingText}</div>
            </div>

            <!-- 视频加载错误 -->
            <div id="videoError" style="display: ${this.videoLoadingError ? 'flex' : 'none'}; flex-direction: column; align-items: center; justify-content: center; z-index: 10;">
              <div style="font-size: 24px; color: #ff4d4f; margin-bottom: 10px;">⚠️</div>
              <div style="color: #ff4d4f; font-size: 14px; text-align: center;min-width:200px; max-width: 80%;">${this.videoLoadingText}</div>
            </div>

            <style>
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            </style>
          </div>
          <div v-else style="position: absolute; left: 0; top: 0;width: 460px; height: 240px;">
            <div id="hstplayer"  v-if="${!this.IsHai} style="width: 460px; height: 200px;"></div>
            <div id="divPlugin" class="divPlugin" style="width: 460px; height: 200px;" ref="divPlugin" v-if="${this.IsHai}"> </div>
          </div>
        <div style="display: flex;justify-content: space-between;margin-top: 15px;margin-bottom: 12px;margin-top:100px">
          <div style="font-weight: 500;font-size: 18px;color: rgba(0, 0, 0, 0.85);line-height: 25px;">车牌号：${record.vehicleNumber || ""
        }</div>
          <div style="font-weight: 500; font-size: 18px;color: rgba(0, 0, 0, 0.85);line-height: 25px;">驾驶员：${record.driverName || ""
        }</div>
        </div>
        <div style="display: flex; justify-content: space-between">
          <div style="font-weight: 500; font-size: 14px; color: rgba(0, 0, 0, 0.65);line-height: 26px;width: 200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" title="${record.location
        }">位置：${record.location}</div>
          <div style="font-weight: 500;font-size: 14px; color: rgba(0, 0, 0, 0.65);line-height: 26px;">经纬度：${record.longitude + "," + record.latitude
        }</div>
        </div>
        <div style="display: flex; justify-content: space-between">
          <div style="font-weight: 500;font-size: 14px; color: rgba(0, 0, 0, 0.65);line-height: 26px;">当前时速：${record.speed || ""
        }${record.speed && "km/h"}</div>
          <div style="font-weight: 500;font-size: 14px; color: rgba(0, 0, 0, 0.65);line-height: 26px;">驾驶时长：${record.drivingTime
        }</div>
        </div>
        <div style="margin-top: 14px;display: flex;justify-content: flex-end;align-items: center;cursor: pointer;" onclick="toCarDetail(${record.id
        })">
          <div style="font-weight: 400;font-size: 18px; color: rgba(22, 119, 255, 1);line-height: 25px;">车辆详情</div>
          <img style="width:18px;height: 18px;margin-left: 8px;" src="${require("../../assets//homeImg/right.png")}" />
        </div>
      </div>`;
    },
    formatterTime(value) {
      if (!value) return "";
      const hours = Math.floor(value / 60);
      const minutes = value % 60;
      if (hours > 0) {
        return `${hours}小时${minutes}分钟`;
      } else {
        return `${minutes}分钟`;
      }
    },
    // 获取预警情况统计
    getCountList() {
      echarts.dispose(document.getElementById("countChart"));
      if (this.countList.length > 0) {
        this.chartTnit();
      }
    },
    chartTnit() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.getElementById("countChart"));
      // 绘制数量图表
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          width: "auto",
          height: "auto",
          top: "5%",
          left: "3%",
          right: "4%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.countList.map((item) => item.warnType),
            axisTick: {
              alignWithLabel: true,
              lineStyle: {
                color: "#777777",
              },
            },
            axisLabel: {
              color: "rgba(0, 0, 0, 0.45)",
              interval: 0, // 强制显示所有标签
              width: 60, // 设置标签宽度
              height: 20, // 设置标签高度
              overflow: 'truncate', // 截断模式
              ellipsis: true, // 超出显示省略号
              rotate: -40, // 可以根据需要调整角度
              formatter: function (value) {
                if (value.length > 4) {
                  return value.substring(0, 4) + '...';
                }
                return value;
              }
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            type: "bar",
            barWidth: "20px",
            itemStyle: {
              borderRadius: [20, 20, 20, 20],
              color: (params) => {
                return [
                  "#5B8FF9",
                  "#5AD8A6",
                  "#F6BD16",
                  "#6DC8EC",
                  "#945FB9",
                  "rgba(248, 204, 65, 0.5)",
                  "rgba(2, 179, 118, 0.5)",
                  "rgba(254, 41, 94, 0.5)",
                  "rgba(255, 102, 39, 0.5)",
                  "rgba(169, 14, 253, 0.5)",
                  "rgba(109, 200, 236, 0.5)",
                ][params.dataIndex];
              },
            },
            data: this.countList.map((item) => item.num),
          },
        ],
      });
      myChart.resize();
    },

    // 跳转车辆详情
    toCarDetail(id) {
      this.$router.push({
        path: "/car-detail",
        query: {
          id: id,
        },
      });
    },
    fullScreen() {
      const video = document.getElementById("monitoringCard");
      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if (video.mozRequestFullScreen) {
        // Firefox
        video.mozRequestFullScreen();
      } else if (video.webkitRequestFullscreen) {
        // Chrome, Safari and Opera
        video.webkitRequestFullscreen();
      } else if (video.msRequestFullscreen) {
        // IE/Edge
        video.msRequestFullscreen();
      }
    },
    getRandomColor() {
      const letters = "0123456789ABCDEF";
      let color = "#";
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    shotScreen() {
      // 获取video和canvas元素
      const video = document.getElementById("monitoringCard");
      const canvas = document.getElementById("myCanvas");
      // 设置canvas的宽度和高度与video相同
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      // 获取canvas的2d绘图上下文
      const context = canvas.getContext("2d");
      // 将当前video帧绘制到canvas上
      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      setTimeout(() => {
        // 将canvas内容转换为图片
        let dataURL = canvas.toDataURL("image/png");
        this.downloadImage(dataURL);
      }, 100);
    },
    downloadImage(base64) {
      const link = document.createElement("a");
      link.href = base64;
      link.download = "screenshot.png"; // 你希望下载的文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    initPlugin() {
      let _this = this
      this.oWebControl = new WebControl({
        szPluginContainer: "divPlugin",
        iServicePortStart: 15900,
        iServicePortEnd: 15909,
        // 用于 IE10 使用 ActiveX 的 clsid
        szClassId: "23BF3B0A-2C56-4D97-9C03-0CB103AA8F11",
        cbConnectSuccess: (e) => {
          console.log('连接成功')
          this.plugin = true;
          _this.setCallbacks();
          if (_this.oWebControl) {
            _this.oWebControl.JS_StartService("window", {
              dllPath: "./VideoPluginConnect.dll"
              //dllPath: "./DllForTest-Win32.dll"
            }).then((res) => {
              _this.oWebControl.JS_CreateWnd("divPlugin", _this.videoWidth, _this.videoHeight).then(() => {
                console.log("JS_CreateWnd success");
                _this.initVideo();
              });
            }, function () {
            });
          } else {
          }
        },
        cbConnectError: () => {
          console.log("cbConnectError");
          _this.oWebControl = null;
          $("#divPlugin").html("插件未启动，正在尝试启动，请稍候...");
          WebControl.JS_WakeUp("VideoWebPlugin://");
          _this.initCount++;
          if (_this.initCount < 3) {
            setTimeout(() => {
              _this.initPlugin();
            }, 3000)
          } else {
            $("#divPlugin").html("插件启动失败，请检查插件是否安装！");
            this.plugin = false;
          }
        },
        cbConnectClose: () => {
          console.log("cbConnectClose");
          this.oWebControl.JS_Disconnect().then(function () { }, function () { });
          this.oWebControl = null;
        }
      });
    },
    // 设置窗口控制回调
    setCallbacks() {
      this.oWebControl.JS_SetWindowControlCallback({
        cbIntegrationCallBack: this.cbIntegrationCallBack
      });
    },
    // 推送消息
    cbIntegrationCallBack(oData) {
      this.$message.warning((JSON.stringify(oData.responseMsg)));
    },
    // 初始化参数
    initVideo() {
      this.getPubKey(() => {
        let appkey = this.video_init_data.appkey;
        let secret = this.setEncrypt(this.video_init_data.appSecret);
        let ip = this.video_init_data.ip;
        let szPort = this.video_init_data.port;
        let snapDir = this.video_init_data.snapDir;
        let videoDir = this.video_init_data.videoDir;
        let layout = this.video_init_data.layout;
        let encryptedFields = ['secret'];

        appkey = appkey.replace(/(^\s*)/g, "");
        appkey = appkey.replace(/(\s*$)/g, "");

        secret = secret.replace(/(^\s*)/g, "");
        secret = secret.replace(/(\s*$)/g, "");

        ip = ip.replace(/(^\s*)/g, "");
        ip = ip.replace(/(\s*$)/g, "");

        szPort = szPort.replace(/(^\s*)/g, "");
        szPort = szPort.replace(/(\s*$)/g, "");

        snapDir = snapDir.replace(/(^\s*)/g, "");
        snapDir = snapDir.replace(/(\s*$)/g, "");

        videoDir = videoDir.replace(/(^\s*)/g, "");
        videoDir = videoDir.replace(/(\s*$)/g, "");

        let port = parseInt(szPort);
        let enableHttps = parseInt(this.video_init_data.enableHttps);

        encryptedFields = encryptedFields.join(",");
        this.oWebControl.JS_RequestInterface({
          funcName: "init",
          argument: JSON.stringify({
            appkey: appkey,
            secret: secret,
            ip: ip,
            playMode: 0, // 预览
            port: port,
            snapDir: snapDir,
            videoDir: videoDir,
            layout: layout,
            enableHTTPS: enableHttps,
            encryptedFields: encryptedFields
          })
        }).then((res) => {
          console.log('初始化成功')
          this.oWebControl.JS_Resize(this.videoWidth, this.videoHeight);
          this.setWndCover();
          this.startRealPlay();
        });
      })
    },
    // 获取公钥
    getPubKey(callback) {
      this.oWebControl.JS_RequestInterface({
        funcName: "getRSAPubKey",
        argument: JSON.stringify({
          keyLength: 1024
        })
      }).then((oData) => {
        // console.log(oData)
        if (oData.responseMsg.data) {
          this.pubKey = oData.responseMsg.data
          callback()
        }
      })
    },
    // RSA加密
    setEncrypt(value) {
      if (!this.pubKey) {
        console.log('请先获取公钥')
        return
      }
      let encrypt = new JSEncrypt();
      encrypt.setPublicKey(this.pubKey);
      return encrypt.encrypt(value);
    },
    // 视频预览
    startRealPlay(IndexCode) {
      console.log('------开始播放-------')
      let cameraIndexCode = IndexCode ? IndexCode : this.video_play_data.cameraIndexCode;
      let streamMode = this.video_play_data.streamMode;
      let transMode = this.video_play_data.transMode;
      let gpuMode = this.video_play_data.gpuMode;
      let wndId = -1;  //默认为空闲窗口回放

      cameraIndexCode = cameraIndexCode.replace(/(^\s*)/g, "");
      cameraIndexCode = cameraIndexCode.replace(/(\s*$)/g, "");
      this.oWebControl.JS_RequestInterface({
        funcName: "startPreview",
        argument: JSON.stringify({
          cameraIndexCode: cameraIndexCode,
          streamMode: streamMode,
          transMode: transMode,
          gpuMode: gpuMode,
          wndId: wndId
        })
      }).then(function (oData) {
        console.log('播放成功')
      });
    },
    //根据窗口变化设置视频插件大小
    resizewindow(w, h) {
      console.log('resize')
      w = (w < 1423) ? 1423 : w
      h = (h < 754) ? 754 : h
      window.resizeTo(w, h);
    },
    //设置窗口遮挡
    setWndCover() {
      console.log("setWndCover", this.oWebControl);

      let iWidth = document.body.clientWidth;
      let iHeight = document.body.clientHeight;
      let oDivRect = document.getElementById("divPlugin").getBoundingClientRect();
      let iCoverLeft = (oDivRect.left < 0) ? Math.abs(oDivRect.left) : 0;
      let iCoverTop = (oDivRect.top < 0) ? Math.abs(oDivRect.top) : 0;
      let iCoverRight = (oDivRect.right - iWidth > 0) ? Math.round(oDivRect.right - iWidth) : 0;
      let iCoverBottom = (oDivRect.bottom - iHeight > 0) ? Math.round(oDivRect.bottom - iHeight) : 0;
      console.log("iCoverLeft", iWidth, iHeight, oDivRect, iCoverLeft, iCoverTop, iCoverRight, iCoverBottom);

      iCoverLeft = (iCoverLeft > 700) ? 700 : iCoverLeft;
      iCoverTop = (iCoverTop > 400) ? 400 : iCoverTop;
      iCoverRight = (iCoverRight > 700) ? 700 : iCoverRight;
      iCoverBottom = (iCoverBottom > 400) ? 400 : iCoverBottom;
      if (this.iLastCoverLeft != iCoverLeft) {
        console.log("iCoverLeft: " + iCoverLeft);
        this.iLastCoverLeft = iCoverLeft;
        this.oWebControl.JS_SetWndCover("left", iCoverLeft);
      }
      if (this.iLastCoverTop != iCoverTop) {
        console.log("iCoverTop: " + iCoverTop);
        this.iLastCoverTop = iCoverTop;
        this.oWebControl.JS_SetWndCover("top", iCoverTop);
      }
      if (this.iLastCoverRight != iCoverRight) {
        console.log("iCoverRight: " + iCoverRight);
        this.iLastCoverRight = iCoverRight;
        this.oWebControl.JS_SetWndCover("right", iCoverRight);
      }
      if (this.iLastCoverBottom != iCoverBottom) {
        console.log("iCoverBottom: " + iCoverBottom);
        this.iLastCoverBottom = iCoverBottom;
        this.oWebControl.JS_SetWndCover("bottom", iCoverBottom);
      }
    },
    //关闭所有的播放画面
    close_all() {
      this.oWebControl.JS_RequestInterface({
        funcName: "stopAllPreview"
      }).then(function (oData) {
        console.log(JSON.stringify(oData ? oData.responseMsg : ''))
      });
    },
    loadScripts() {
      return new Promise((resolve, reject) => {
        const scripts = [
          '/scripts/jquery-1.7.1.min.js',
          '/scripts/md5.js',
          '/scripts/request.js',
          '/scripts/swfobject-all.js',
          '/scripts/swfobject-play.js',
          '/scripts/swfobject-h5.js',
          '/scripts/flv.min.js',
          '/scripts/DPlayer.min.js',
          '/scripts/HZPlayer.js',
          '/scripts/HZRecorder.js'
        ];

        const loadScript = (index) => {
          if (index >= scripts.length) {
            resolve();
            return;
          }

          const script = document.createElement('script');
          script.src = scripts[index];
          script.onload = () => loadScript(index + 1);
          script.onerror = reject;
          document.head.appendChild(script);
        };

        loadScript(0);
      });
    },

  },
};
</script>

<style scoped lang="less">
.homePage {
  display: flex;
  height: 100%;
  position: relative;
  background: #f4f4ff;

  .left {
    flex: 1;

    .leftContent {
      display: flex;
      height: calc(100% - 138px);
      padding-top: 20px;

      .title {
        font-weight: 600;
        font-size: 18px;
        color: #fff;
        line-height: 25px;
        text-transform: none;
        // padding: 5px 0;

      }

      .title4 {
        background: url("../../assets/img2.png") no-repeat center center;
        background-size: 100% 100%;
        padding: 4px 18px 4px 14px;
        width: 150px;
      }

      .title:nth-child(1) {}




      .leftData {
        display: flex;
        flex-direction: column;
        width: 443px;
        height: 100%;
        padding-right: 20px;

      }

      .warnCount {
        // position: relative;
        flex: 1;
        padding: 10px;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        border-radius: 10px 10px 0px 0px;
        background: #f4f4ff;
        // margin-bottom: 10px;

        #countChart {
          width: 100%;
          height: 88%;
        }

        .title {
          // background: url("../../assets/3.png") no-repeat center center;
          // background-size: 100% 100%;
          // padding-left: 14px;
        }

        .title1 {
          background: url("../../assets/img2.png") no-repeat center center;
          background-size: 100% 100%;
          padding: 4px 14px;
          width: 150px;
        }

        .title2 {
          background: url("../../assets/img2.png") no-repeat center center;
          background-size: 100% 100%;
          padding: 4px 14px;
          width: 150px;
        }



        .noData {
          display: flex;
          flex-direction: column;
          align-content: center;
          justify-content: center;
          // position: absolute;
          // bottom: 0;
          // left: 0;
          width: 100%;
          height: 180px;
        }
      }

      .warnRank {
        flex: 1;
        position: relative;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        border-radius: 10px 10px 0px 0px;
        background: #f4f4ff;
        padding: 10px;
        margin-top: 10px;

        .title {}

        .title3 {
          background: url("../../assets/img2.png") no-repeat center center;
          background-size: 100% 100%;
          padding: 4px 14px;
          width: 150px;
        }

        .rankChart {
          padding: 5px;
          width: 100%;
          height: 90%;
          margin-top: 10px;
          padding-top: 10px;
          background: #fff;
          // height: 300px;

          .rankItem {
            display: flex;
            align-content: center;
            margin-bottom: 24px;

            .left {
              flex: 2;
              padding-right: 25px;
              font-weight: 400;
              font-size: 13px;
              color: rgba(0, 0, 0, 0.45);
              line-height: 17px;
              text-align: right;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            .rankRight {
              flex: 5;
              height: 15px;
              background: rgba(93, 112, 146, 0.2);
              border-radius: 8px;

              .rank {
                height: 15px;
                border-radius: 8px;
                background: rgba(93, 112, 146, 0.6);
              }
            }

            .rankColor {
              background: rgba(91, 143, 249, 0.2);

              .rank {
                background: rgba(91, 143, 249, 0.85);
              }
            }
          }

          .rankItem:last-child {
            margin-bottom: 0 !important;
          }
        }

        .noData {
          display: flex;
          flex-direction: column;
          align-content: center;
          justify-content: center;
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 300px;
        }
      }
    }
  }

  .leftMap {
    // width: 100%;
    height: 100%;
    flex: 3;
    display: flex;
    position: relative;

    #mapContainer {
      flex: 1;
      width: 100%;
      height: 100%;
    }
  }

  .mapTop {
    z-index: 99;
    // position: absolute;
    // top: 20px;
    // left: 20px;
    // right: 513px;
    display: flex;
    justify-content: space-between;
    width: calc(100%);

    .title {
      font-weight: 600;
      font-size: 18px;
      color: #000000;
      line-height: 25px;
      text-transform: none;
      text-align: center;
    }

    .carCount {
      flex: 8;
      background: #f4f4ff;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      padding: 14px 20px 14px 20px;
      margin-right: 20px;

      .fir {
        display: flex;
        justify-content: space-between;

        .countCard {
          background: #ffffff;
          margin-right: 20px;
          padding: 14px 14px 18px 24px;
        }

        .countCard:last-child {
          margin-right: none;
        }
      }

      .sec {
        display: flex;
        justify-content: space-between;

        .countCard {
          background: #ffffff;
          margin-right: 15px;
        }

        .countCard:last-child {
          margin-right: none;
        }
      }

      .countCard {
        flex: 1;
        background: linear-gradient(180deg,
            rgba(246, 246, 252, 0) 0%,
            #f3f4f8 100%);
        box-shadow: inset 0px -1px 4px 0px #ffffff;
        border-radius: 10px;
        border: 1px solid #f1f1f1;
        padding: 14px 20px 18px 14px;
        display: flex;
        // justify-content: space-between;

        .iconImg {
          width: 30px;
          height: 30px;
          border-radius: 10px;
          margin-right: 25px;
        }

        .iconImg:nth-child(1) {
          box-shadow: 0px 7px 14px 0px rgba(14, 110, 253, 0.4);
        }

        .iconImg:nth-child(2) {
          box-shadow: 0px 7px 14px 0px rgba(255, 102, 39, 0.5);
        }

        .iconImg:nth-child(3) {
          box-shadow: 0px 7px 14px 0px rgba(254, 41, 94, 0.5);
        }

        .iconImg:nth-child(4) {
          box-shadow: 0px 7px 14px 0px rgba(248, 204, 65, 0.5);
        }

        .iconImg:nth-child(5) {
          box-shadow: 0px 7px 14px 0px rgba(2, 179, 118, 0.5);
        }

        .iconImg:nth-child(6) {
          box-shadow: 0px 7px 14px 0px rgba(169, 14, 253, 0.4);
        }

        .iconImg:nth-child(7) {
          box-shadow: 0px 7px 14px 0px rgba(109, 200, 236, 0.5);
        }

        .name {
          font-weight: 500;
          font-size: 12px;
          color: rgba(0, 0, 0, 0.6);
          line-height: 17px;
          margin-top: 2px;
        }

        .num {
          font-weight: 900;
          font-size: 16px;
          color: rgba(0, 0, 0, 0.8);
          line-height: 19px;
          text-align: left;
          margin-top: 1px;
        }
      }
    }

    .carStatus {
      flex: 5;
      background: #f4f4ff;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      padding: 14px 84px 20px 84px;

      .statusFir {
        margin-top: 23px;
        margin-bottom: 28px;
        display: flex;
        justify-content: space-between;
        align-content: center;
      }

      .statusSec {
        display: flex;
        justify-content: space-between;
        align-content: center;
      }

      .statusCard {
        display: flex;
        align-content: center;

        .statusLeft {
          margin-right: 9px;
          display: flex;
          flex-direction: column;
          justify-content: center;

          .name {
            font-weight: 500;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.6);
            line-height: 17px;
          }

          .num {
            font-weight: 900;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.8);
            line-height: 19px;
          }
        }

        .progressCard {
          width: 56px;
          height: 56px;

          ::v-deep .el-progress-circle {
            width: 56px !important;
            height: 56px !important;
          }
        }
      }

      .statusLine {
        width: 1px;
        height: 46px;
        border: 1px solid #dedede;
        box-sizing: border-box;
      }
    }

    .firCard {
      display: flex;
      justify-content: space-between;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
      border-radius: 10px 10px 0px 0px;
      background: #f4f4ff;
      // margin-bottom: 10px;
      padding: 10px;
      width: 423px;
      padding-left: 20px;

      .companyCard {
        width: 100px;
        // height: 90px;
        background: #fff;
        border-radius: 0px 10px 10px 0px;
        position: relative;


        .lineCard {
          position: absolute;
          left: 0;
          top: 0;
          width: 4px;
          // height: 90px;
          background: #0e6efd;
          border-radius: 2px;
        }

        .name {
          margin: 18px 10px 12px 10px;
          text-align: left;
          font-size: 12px;
          color: rgba(0, 0, 0, 0.6);
          line-height: 17px;
        }

        .value {
          padding-left: 10px;
          margin-bottom: 12px;
          text-align: left;
          font-weight: 900;
          font-size: 18px;
          color: #0e6efd;
          line-height: 21px;
        }

        .onLine {
          color: #000000;
        }

        .breakdown {
          color: #ffa500;
        }

        .abnormal {
          color: #ff0000;
        }

      }

      .companyCard:nth-child(2) {
        flex: 1;
        margin-left: 10px;
        display: flex;
        justify-content: space-between;
        padding-right: 10px;

        .statusLeft {
          text-align: left;

          .num {
            padding-left: 10px;
            // padding-right: 10px;
          }
        }

      }
    }
  }

  .right {
    // position: absolute;
    // right: 0;
    // top: 0;
    width: 443px;
    height: 100%;
    // flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    // margin: 20px 17px 0 20px;
    background: transparent;
    // box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    // border-radius: 10px 10px 0px 0px;
    padding: 0 0 0 20px;
    // overflow-y: auto;

    .title {
      padding: 5px 0;
      font-weight: 600;
      font-size: 18px;
      color: #fff;
      line-height: 25px;
      text-transform: none;
    }

    .mt-0 {
      margin-top: 0 !important;
    }

    .firCard {
      display: flex;
      justify-content: space-between;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
      border-radius: 10px 10px 0px 0px;
      background: #f4f4ff;
      margin-bottom: 10px;
      padding: 10px;

      .companyCard {
        width: 100px;
        // height: 90px;
        background: #fff;
        border-radius: 0px 10px 10px 0px;
        position: relative;


        .lineCard {
          position: absolute;
          left: 0;
          top: 0;
          width: 4px;
          // height: 90px;
          background: #0e6efd;
          border-radius: 2px;
        }

        .name {
          margin: 18px 10px 12px 10px;
          text-align: left;
          font-size: 12px;
          color: rgba(0, 0, 0, 0.6);
          line-height: 17px;
        }

        .value {
          padding-left: 10px;
          margin-bottom: 22px;
          text-align: left;
          font-weight: 900;
          font-size: 18px;
          color: #0e6efd;
          line-height: 21px;
        }
      }

      .companyCard:nth-child(2) {
        flex: 1;
        margin-left: 10px;
        display: flex;
        justify-content: space-between;
        padding-right: 10px;

        .statusLeft {
          text-align: left;

          .num {
            padding-left: 10px;
            // padding-right: 10px;
          }
        }

      }
    }

    .todayWarn {
      height: 50%;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
      border-radius: 10px 10px 0px 0px;
      background: #f4f4ff;
      margin-bottom: 10px;
      padding: 10px;
      flex: 1;

      .warnList {
        margin-top: 5px;
        height: calc(100% - 45px);
        overflow-y: auto;
        // box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        border-radius: 10px 10px 0px 0px;
        background-color: #fff;

        .warnItem {
          height: 26px;
          background: rgba(39, 129, 255, 0.06);
          border-radius: 4px;
          padding: 2px;
          display: flex;
          align-content: center;
          margin-bottom: 10px;

          .grade {
            height: 22px;
            background: #e6f4ff;
            border-radius: 4px;
            border: 1px solid #bae0ff;
            margin-right: 11px;
            box-sizing: border-box;
            padding: 1px 8px;

            font-weight: 400;
            font-size: 12px;
            color: #1677ff;
            line-height: 20px;
          }

          .info {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.8);
            line-height: 26px;
          }
        }

        .warnItem:last-child {
          margin-bottom: 0 !important;
        }

        .oneWarn {
          background: rgba(255, 77, 79, 0.06);

          .grade {
            background: #fff1f0;
            border: 1px solid #ffccc7;
            color: rgba(255, 77, 79, 1);
          }
        }

        .twoWarn {
          background: rgba(250, 173, 20, 0.06);

          .grade {
            background: #fffbe6;
            border-radius: 4px;
            border: 1px solid #fff1b8;
            color: rgba(250, 173, 20, 1);
          }
        }

        .threeWarn {
          background: rgba(39, 129, 255, 0.06);

          .grade {
            background: #e6f4ff;
            border: 1px solid #bae0ff;
            color: #1677ff;
          }
        }

        .fourWarn {
          background: rgba(82, 196, 26, 0.06);

          .grade {
            background: #f6ffed;
            border-radius: 4px;
            border: 1px solid #d9f7be;
            color: rgba(82, 196, 26, 1);
          }
        }

        .fiveWarn {
          background: rgba(214, 219, 228, 0.3);

          .grade {
            background: rgba(214, 219, 228, 0.3);
            border-radius: 4px;
            border: 1px solid rgba(214, 219, 228, 0.6);
            color: rgba(0, 0, 0, 0.8);
          }
        }
      }

      .warnList::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        background-color: #f5f5f5;
      }

      .warnList::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 4px;
      }

      .warnList::-webkit-scrollbar-thumb:hover {
        background-color: #aaa;
      }
    }

    .warnCount {
      // position: relative;
      padding: 10px;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
      border-radius: 10px 10px 0px 0px;
      background: #f4f4ff;
      margin-bottom: 0px !important;
      flex: 1;


      .title {
        // background: url("../../assets/5.png") no-repeat center center !important;
        // background-size: 100% 100% !important;
        // padding-left: 14px;
      }

      #countChart {
        width: 100%;
        height: 100%;
      }

      .noData {
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        // position: absolute;
        // bottom: 0;
        // left: 0;
        width: 100%;
        height: 180px;
      }
    }

    .warnRank {
      position: relative;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
      border-radius: 10px 10px 0px 0px;
      background: #f4f4ff;
      padding: 10px;
      flex: 1;

      .rankChart {
        padding: 5px;
        width: 100%;
        background: #fff;
        // height: 300px;

        .rankItem {
          display: flex;
          align-content: center;
          margin-bottom: 14px;

          .left {
            flex: 2;
            padding-right: 25px;
            font-weight: 400;
            font-size: 13px;
            color: rgba(0, 0, 0, 0.45);
            line-height: 17px;
            text-align: right;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .rankRight {
            flex: 5;
            height: 15px;
            background: rgba(93, 112, 146, 0.2);
            border-radius: 8px;

            .rank {
              height: 15px;
              border-radius: 8px;
              background: rgba(93, 112, 146, 0.6);
            }
          }

          .rankColor {
            background: rgba(91, 143, 249, 0.2);

            .rank {
              background: rgba(91, 143, 249, 0.85);
            }
          }
        }

        .rankItem:last-child {
          margin-bottom: 0 !important;
        }
      }

      .noData {
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 300px;
      }
    }
  }

  ::v-deep .el-table .el-table__cell {
    padding: 8px 0px !important;
  }
}

.operate_type {
  color: #1677ff;
  cursor: pointer;

  &:hover {
    color: #0052d9;
  }

  text-decoration: underline;
}
</style>
